import { object } from "../helpers/object";
import { debug } from "../helpers/debug";

import { animation } from "../helpers/animation";
import { stack } from "../helpers/stack";


/*------------------------------------*\
  #SCROLLTOTOP

  Gestion des scrollToTops
\*------------------------------------*/
class ScrollToTop {


  constructor(module){
    this.MODULE = module;
    this.DOM_MODULE = object.toArray(document.querySelectorAll(this.MODULE));
  }
  /**
   * INITIALISATION
   * @returns 
   */
  init = () => {
    if (!this.DOM_MODULE.length) return;
    // DEFAULT EVENT
    document.addEventListener('click', this.clickHandler);
    // SCROLL EVENT HANDLER
    document.addEventListener('scroll', this.scrollHandler);
    this.activeOnScrollHandler();

    stack.create('ScrollToTop', this.DOM_MODULE[0], 'bottom');

    if(debug.DEBUG) console.log('components/scroll-to-top.js');
  };

  /**
   * CLICK HANDLER
   * 
   * Gestionnaire des event de la barre de navigation
   * @param {event} event 
   * @returns 
   */
  clickHandler = (event) => {
    if (event.target.matches('[data-js-trigger="scroll-to-top"]')) {
      animation.scrollTo(0, 2000);
    }
  }
  /**
   * SCROLL HANDLER
   * @param {event} event 
   */
  scrollHandler = (event) => {
    this.activeOnScrollHandler();
  };
  /**
   * ACTIVE ON SCROLL HANDLER
   */
  activeOnScrollHandler = () => {
    const scrollY = window.scrollY;
    const isActive = scrollY > 400;
    const domModule = this.DOM_MODULE[0];
    const button = domModule.querySelector('button');
    const footerOffsetTop = document.querySelector("footer").offsetTop;
    const gap = Math.max(scrollY - (footerOffsetTop + stack.getPreviousStack('ScrollToTop', 'bottom') - window.innerHeight), 0);
  
    domModule.setAttribute('aria-hidden', !isActive);
    button.setAttribute('tabindex', isActive ? 0 : -1);
    domModule.style.setProperty('--scroll-to-top-gap', `${gap}px`);
  }
}
export const scrollToTop = new ScrollToTop('[data-js-component="scroll-to-top"]'); 